<template lang="pug">
.app--header
  .app--header-content.content-container
    .heading-bar
      .logo-container.finger(@click="handleNaviClick(navigationList.find(item => item.name === 'portalHome'))")
        img(src="@/assets/logo.svg")
      .search-container
        .search-input-wrapper
          input.input(placeholder="输入关键词搜索" v-model="search.keyword" @keyup.enter="handleSearch")
          .button-search(@click="handleSearch")
            img(src="@/assets/home/search.svg")
        .search-heat-words
          .heat-word(v-for="(word, wordIndex) in search.heatWords" :key="wordIndex"
            @click="handleHeatWordClick(word)") {{ word }}
      .user-container
        .logged-container(v-if="logged")
          .greeting 欢迎您，
          .user(@click="toManager('profile')")
            .nickname {{ userInfo.nickname }}
            i.el-icon-arrow-right
          //.notify(@click="toManager('message')")
            i.el-icon-bell
        .not-logged-container(v-else)
          .greeting 欢迎您，你还未登录
          .button-sign-in(@click="handleLogin('signIn')") 登录
          .button-sign-up(@click="handleLogin('signUp')") 注册
    .navigation-bar
      .navigation-item(v-for="navi in navigationList" :key="navi.name"
        :class="{'active': currentNavi(navi)}"
        @click="handleNaviClick(navi)") {{ navi.meta.nameCN }}
  AppLoginModal(ref="AppLoginModal")
</template>

<script>
import PortalRoute from "@/router/portal.route";
import AppLoginModal from "@/components/common/AppLoginModal";
import {mapGetters} from "vuex";
import _ from 'lodash';

export default {
  name: "AppHeader",
  components: {
    AppLoginModal,
  },
  data() {
    return {
      search: {
        keyword: '',
        heatWords: ['辣椒', '油麦菜', '娃娃菜', '上海青', '菠菜']
      }
    }
  },
  computed: {
    ...mapGetters({
      logged: 'auth/logged',
      userInfo: 'auth/userInfo',
    }),
    navigationList() {
      return PortalRoute.filter(item => item.meta.showInNav);
    },
    currentNavi() {
      return nav => this.$route.path.includes(nav.path);
    }
  },
  methods: {
    handleNaviClick(navi) {
      if(this.$route.name !== navi.name) {
        this.$router.push(navi);
      }
    },
    handleLogin(type) {
      this.$refs.AppLoginModal.$open(type);
    },
    handleHeatWordClick(word) {
      this.search.keyword = word;
      this.handleSearch();
    },
    handleSearch() {
      if(!_.isEmpty(this.search.keyword)) {
        this.$router.replace({
          name: 'portalSearch',
          query: {
            keyword: this.search.keyword,
          }
        });
      }
    },
    toManager(target) {
      this.$router.push({
        name: `manager${_.capitalize(target)}`,
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app--header{
  background-color: white;
  height: 164px;
  padding: 24px 0 14px;
  box-sizing: border-box;
  .app--header-content{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .heading-bar{
      display: flex;
      justify-content: space-between;
      .search-container{
        .search-input-wrapper{
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          .input{
            border: 2px $main_color solid;
            width: 332px;
            height: 40px;
            box-sizing: border-box;
            font-size: 12px;
            padding-left: 24px;
            outline: none;
          }
          .button-search{
            background-color: $main_color;
            width: 88px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
        }
        .search-heat-words{
          font-size: 12px;
          display: flex;
          .heat-word{
            color: #999999;
            cursor: pointer;
            padding: 0 18px;
            position: relative;
            &:hover{
              color: $main_color;
            }
            & + .heat-word{
              &:before{
                content: '';
                background-color: rgba(0, 0, 0, 0.1);
                display: block;
                @include size(1px, 8px);
                position: absolute;
                left: 0;
                top: 40%;
                transform: translate(-50%, -50%);
              }
            }
          }
        }
      }
      .user-container{
        width: 350px;
        .not-logged-container{
          display: flex;
          align-items: center;
          .greeting{
            font-size: 14px;
            color: rgba(0, 0, 0, 0.4);
            margin-right: 24px;
          }
          .button-sign-in,
          .button-sign-up{
            @include size(72px, 36px);
            line-height: 36px;
            text-align: center;
            cursor: pointer;
            font-size: 14px;
          }
          .button-sign-in{
            background: rgba(255, 92, 0, 0.1);
            color: #FF5C00;
            margin-right: 8px;
          }
          .button-sign-up{
            background: rgba(46, 186, 34, 0.2);
            color: #007739;
          }
        }
        .logged-container{
          display: flex;
          justify-content: flex-end;
          .greeting{
            font-size: 14px;
            color: rgba(0, 0, 0, 0.4);
            margin-right: 8px;
          }
          .user{
            display: flex;
            align-items: center;
            @extend .finger;
            .nickname{
              font-weight: 700;
              color: #202948;
            }
            i{
              margin-left: 8px;
            }
          }
          .notify{
            margin-left: 24px;
          }
        }
      }
    }
    .navigation-bar{
      display: flex;
      justify-content: space-between;
      .navigation-item{
        @include size(116px, 32px);
        line-height: 32px;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
        color: rgba(32, 41, 72, 0.6);
        &:hover{
          color: $main_color;
        }
        &.active{
          background-color: $main_color;
          color: white;
        }
      }
    }
  }
}
</style>
